export default "__VITE_ASSET__BI4T9CW7__"